// From Iconoir — used via Iconify (https://iconify.design)
import type { SVGProps } from "react";

export function MicrophoneIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <g fill="none" stroke="currentColor" strokeWidth="1.5"><rect width="6" height="12" x="9" y="2" rx="3"/><path strokeLinecap="round" strokeLinejoin="round" d="M5 10v1a7 7 0 0 0 7 7v0a7 7 0 0 0 7-7v-1m-7 8v4m0 0H9m3 0h3"/></g>
    </svg>
  );
}
